import React from "react";
import { message } from "antd";

import { DeleteIcon } from "src/components";
import { compose } from "src/helpers";
import { withDeleteStudent } from "src/modules/student/operations";
import { captureException } from "@sentry/react";

const DeleteView = (props) => {
    const { deleteStudent, id } = props;

    const handleDelete = async () => {
        try {
            await deleteStudent(id);
            message.success("Deleted!");
        } catch (err) {
            captureException(err)
            message.error("Failed!");
        }
    };

    return <DeleteIcon {...props} onConfirm={handleDelete} />;
};

export default compose(withDeleteStudent)(DeleteView);
